import { ColoursObj, Typography } from "@eventr/common-storybook";
import { useMemo } from "react";
import { useSectionV2Context } from "../../state/sectionProvider";
import { useObjectContext } from "../providers/objectProvider";

interface ICounterProps {
  count: number;
  bgColourOverwrite?: string;
}

export const Counter = ({ count, bgColourOverwrite }: ICounterProps) => {
  const { past } = useObjectContext();
  const { isPublic } = useSectionV2Context();
  const backgroundColor = useMemo(() => {
    if (bgColourOverwrite) return bgColourOverwrite;
    if (past) return ColoursObj.shades.shade2;
    if (isPublic) return ColoursObj.coreBrights.tertiary;
    return ColoursObj.core.secondary;
  }, [isPublic, past, bgColourOverwrite]);
  return (
    <Typography
      id="counter"
      sx={{
        padding: "4px 8px",
        gap: "8px",
        borderRadius: "4px",
        background: "#EDF3F4",
        lineHeight: "16px",
        fontWeight: "300",
        fontSize: "12px",
        backgroundColor: backgroundColor,
        color: ColoursObj.backgrounds.primary,
      }}
      variant="bodyBold"
    >
      {count.toString() ?? "0"}
    </Typography>
  );
};
